<template>
  <div>
    <div id="ratio_chart"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
    props:{
        price:{
            type:Array,
        },
        ratio:{
            type:Array,
        },
    },
    mounted(){
        this.ratio_chart();
    },
    watch:{
        price:{
            handler(val, oldVal){
                if(val){
                    this.ratio_chart();
                }
            },
            deep:true //true 深度监听
        }
    },
    methods:{
        ratio_chart(){
            var price = this.price;
            var ratio = this.ratio;
            function fontSize(res){
                let docEl = document.documentElement,
                    clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
                if (!clientWidth) return;
                let fontSize = (clientWidth / 750);
                return res*fontSize;

            }
            //分离数据
            function splitData(rawData) {
                var time = [];
                var values = []
                for (var i = 0; i < rawData.length; i++) {
                    time.push(time_format(rawData[i].x));
                    values.push(rawData[i].y.toFixed(2))
                }
                return {
                    time: time,
                    values: values
                };
            }
            //格式化时间
            function time_format(time) {
                var t0 = time.split('-')[0];
                var t1 = time.split('-')[1];
                switch (t1){
                    case "03" :
                        t1 =  "Q1";
                        break;
                    case "06":
                        t1 = "Q2";
                        break;
                    case "09" :
                        t1 =  "Q3";
                        break;
                    case "12":
                        t1 = "Q4";
                        break;
                }
                return t0+"."+t1
            }
            //取价格的max,min,range
            var max_price = Math.ceil(Math.max(...splitData(price).values));
            var min_price = Math.floor(Math.min(...splitData(price).values));
            var range =Math.ceil(((max_price-min_price)/4));
            min_price = max_price - range*4;
            //console.log(max_price,min_price,range)
            //绘制图表
            var myChart = echarts.init(document.getElementById('ratio_chart'));
            var option = {
               /* grid:{
                    //top:0,
                    x:80,
                    y:45,
                    x2:45,
                    y2:45
                },*/
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        lineStyle: {
                            color: 'transparent'	//显示竖线颜色
                        }
                    },
                    textStyle: {
                        color: '#333333',
                        fontSize:fontSize(22),
                    },
                    backgroundColor:'#FFFBFB',	//tooltip背景色
                    borderColor:'#FFA391',		//tooltip边框颜色
                    borderWidth:3,
                    formatter: function (param) {	//自定义tooltip内容
                        var text = '';
                        //console.log(param)
                        text += '<div class="tooltip">' +
                            '<div>'+param[0].name+'</div>' +
                            '<div>'+param[0].seriesName+'：<span>'+param[0].data+'%'+'</span></div>' +
                            '<div>'+param[0].seriesName+'：<span>'+param[1].data+'元'+'</span></div>' +
                            '</div>'
                        return text;
                    }
                },
                xAxis: [
                    {
                        type: 'category',
                        data: splitData(ratio).time,
                        axisLine: {
                            lineStyle: {
                                type: 'dashed',
                                color: '#979797',//左边线的颜色
                                width:'1'//坐标线的宽度
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#939393',//坐标值得具体的颜色
                                fontSize: fontSize(20),
                            },
                            margin: 15, // 刻度标签与轴线之间的距离
                        },
                        axisTick: {    // 坐标轴 刻度
                            show: false,  // 是否显示
                        },
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        min: 0,
                        max: 100,
                        interval: 25,
                        axisLabel: {
                            formatter: '{value}%',
                            textStyle: {
                                color: '#939393',//坐标值得具体的颜色
                                fontSize: fontSize(20),
                            },
                            margin: 5, // 刻度标签与轴线之间的距离
                        },
                        //网格样式
                        splitLine: {
                            show: true,
                            lineStyle:{
                                color: ['#979797'],
                                width: 1.5,
                                type: 'dashed'
                            }
                        }
                    },
                    {
                        type: 'value',
                        min: min_price,
                        max: max_price,
                        interval: range,
                        axisLabel: {
                            formatter: '{value} ',
                            textStyle: {
                                color: '#939393',//坐标值得具体的颜色
                                fontSize: fontSize(20),
                            },
                            margin: 5, // 刻度标签与轴线之间的距离
                        },
                        //网格样式
                        splitLine: {
                            show: true,
                            lineStyle:{
                                color: ['#979797'],
                                width: 1.5,
                                type: 'dashed'
                            }
                        }
                    }
                ],
                series: [

                    {
                        name: '机构持股比例',
                        type: 'bar',
                        data: splitData(ratio).values,
                        itemStyle: {    // 图形的形状
                            color: '#63A0FF',
                        },
                        barWidth: 44,  // 柱形的宽度
                    },
                    {
                        name: '股价',
                        type: 'line',
                        yAxisIndex: 1,
                        data: splitData(price).values,
                        color: "#FE484A",//拐点样式
                        symbol:'circle',
                        symbolSize:16,
                        hoverAnimation: false,  // 将鼠标置于拐点上的hover效果去除
                        itemStyle: {    // 图形的形状
                            normal: {
                                lineStyle:{
                                    width:3,  // 设置线宽
                                    type:'solid'  //'dotted'虚线 'solid'实线
                                },
                            },
                            emphasis: {          //突出效果配置(鼠标置于拐点上时)
                                borderColor: '#fff',    //  拐点边框颜色
                                borderWidth: 2,         //  拐点边框宽度
                                shadowColor: '#FE484A', //  阴影颜色
                                shadowBlur: 10,          //  阴影渐变范围控制
                                symbolSize:16,
                            },
                        },
                    }
                ]
            };
            myChart.setOption(option);
        },
    }
}
</script>

<style lang="scss" scope>
  .tooltip{
    line-height: 0.4rem;
    span{
      font-weight: bold;
    }
  }
</style>